function initYbCountdownTime(container) {
  const ybCountdownContent = container.querySelector('.yb-countdown-content');
  if (!ybCountdownContent) return;

  const year = ybCountdownContent.dataset.year;
  const time = ybCountdownContent.dataset.time;
  const date = ybCountdownContent.dataset.date;
  const timezone = ybCountdownContent.dataset.timezone;

  const dateStr = `${year}-${date.replace('.', '-')}`;
  const timeStr = time.replace(/(\d{2}):(\d{2})(AM|PM)/, (match, h, m, meridiem) => {
    let hour = parseInt(h);
    if (meridiem === 'PM' && hour !== 12) hour += 12;
    if (meridiem === 'AM' && hour === 12) hour = 0;
    return `${hour.toString().padStart(2, '0')}:${m}`;
  });

  const eventDate = new Date(`${dateStr} ${timeStr}`);

  const localOffset = new Date().getTimezoneOffset();

  const targetOffset = (() => {
    const match = timezone.match(/^GMT([+-])(\d+)$/);
    if (!match) return 0;
    const [_, sign, hours] = match;
    let offset = sign === '+' ? parseInt(hours) * 60 * -1 : parseInt(hours) * 60;

    const isUSTimezone = timezone.match(/^GMT[-](?:4|5|6|7|8|9|10)$/);
    if (isUSTimezone) {
      const targetDate = new Date(eventDate);
      const dstStart = new Date(targetDate.getFullYear(), 2, 14 - ((targetDate.getDay() + 6) % 7));
      const dstEnd = new Date(targetDate.getFullYear(), 10, 7 - ((targetDate.getDay() + 6) % 7));
      dstStart.setHours(2, 0, 0, 0);
      dstEnd.setHours(2, 0, 0, 0);
      const isDST = targetDate >= dstStart && targetDate < dstEnd;
      offset -= isDST ? 60 : 0;
    }

    return offset;
  })();

  const offsetDiff = targetOffset - localOffset;
  eventDate.setMinutes(eventDate.getMinutes() + offsetDiff);

  const daysElement = ybCountdownContent.querySelector('.countdown-item-days');
  const hoursElement = ybCountdownContent.querySelector('.countdown-item-hours');
  const minutesElement = ybCountdownContent.querySelector('.countdown-item-minutes');
  const secondElement = ybCountdownContent.querySelector('.countdown-item-second');

  if (!daysElement || !hoursElement || !minutesElement || !secondElement) return;

  function updateCountdown() {
    const now = new Date();
    const diff = eventDate - now;

    if (diff <= 0) {
      daysElement.textContent = '00';
      hoursElement.textContent = '00';
      minutesElement.textContent = '00';
      secondElement.textContent = '00';
      clearInterval(intervalId);
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    daysElement.textContent = String(days).padStart(2, '0');
    hoursElement.textContent = String(hours).padStart(2, '0');
    minutesElement.textContent = String(minutes).padStart(2, '0');
    secondElement.textContent = String(seconds).padStart(2, '0');
  }

  updateCountdown();
  const intervalId = setInterval(updateCountdown, 1000);
}

function initAllYbCountdowns(root = document) {
  root.querySelectorAll('.yb-countdown-container').forEach((container) => {
    if (container.dataset.countdownInitialized === 'true') return;
    container.dataset.countdownInitialized = 'true';
    initYbCountdownTime(container);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAllYbCountdowns());
} else {
  initAllYbCountdowns();
}

document.addEventListener('shopify:section:load', (event) => {
  initAllYbCountdowns(event.target);
});
